
import { Component, Prop, Mixins } from "vue-property-decorator";
import EmployeeDetails from "../modals/employee-details.vue";
import { mapState } from "vuex";
import ShiftMixin from "../shift.mixin";
import { AcceptedShift, EmployeeInfo } from "../shift.types";
import { OfficeDto } from "@/types/office.type";
import { PayrollType } from "@/types/enums.type";
import { ShiftDataDto } from "@/types/shift.type";
import { ShiftStatus } from "@/common/constants";

@Component({
  components: {
    EmployeeDetails
  },
  computed: {
    ...mapState("Shift", ["selectedOffice", "shiftData"])
  }
})
export default class ConfirmedCard extends Mixins(ShiftMixin) {
  @Prop() shift!: AcceptedShift;
  
  selectedOffice!: OfficeDto;
  shiftData!: ShiftDataDto;

  employeeInfo: EmployeeInfo | null = null;
  modalShow = false;

  ShiftStatus = ShiftStatus;

  getClasses(val: boolean): string[] {
    return val ? ['fas', 'fa-check-circle'] : ['far', 'fa-circle'];
  }

  get details(): string {
    return [
      this.shift.date.toLocaleDateString("en-US", {
        weekday: 'long',
        month: 'numeric',
        year: 'numeric',
        day: 'numeric'
      }), 
      this.shift.position,
      this.shift.time,
      this.shift.acceptedCounterOffer ? this.shift.acceptedCounterOffer : this.shift.rate
    ].join(' · ')
  }

  get headerText(): string {
    return this.shift.shiftStatus === ShiftStatus.Pending.value
      ? "Awaiting Worker Confirmation"
      : "Score!! Confirmation Received, Shift Filled!!";
  }

  get modalStatus(): number {
    const pendingStatus = ShiftStatus.Pending.getId(this.shiftData.shiftStatuses);
    const confirmedStatus = ShiftStatus.Confirmed.getId(this.shiftData.shiftStatuses);

    return this.shift.shiftStatus === ShiftStatus.Pending.value
      ? pendingStatus ?? confirmedStatus ?? 0
      : confirmedStatus ?? pendingStatus ?? 0;
  }

  get eodValue(): boolean {
    return this.selectedOffice.payroll?.type === PayrollType.EndOfDay;
  }

  showEmployeeDetailsModal(): void {
    this.employeeInfo = {
      id: this.shift.userId,
      name: this.shift.name,
      timeIn: this.getTimes(this.shift.time, 0, " - "),
      timeOut: this.getTimes(this.shift.time, 1, " - "),
      position: this.shift.position,
      rate: this.shift.rate,
      initials: this.getInitials(this.shift.name),
      officeId: this.shift.officeId,
      email: this.shift.email,
      phone: this.shift.phone,
      rating: this.shift.rating,
      date: new Date(this.shift.date),
      isFavorite: this.shift.isFavorite
    };

    this.modalShow = true;
  }

  getInitials (name: string): string {
    const names = name.split(' ');

    return `${names[0].charAt(0)}${names[1] ? names[1].charAt(0) : ''}`
  }

  onDelete(): void {
    this.$emit('delete');
  }
}
